import styled from '@emotion/styled';
import { GeneralFormError } from '@ui-components/neo.tax';

export const StyledModalContainer = styled.div({
  maxWidth: '540px',
});

export const StyledGeneralFormError = styled(GeneralFormError)({
  textAlign: 'left',
});
